import { SharingData } from '../../schema/SharingData';
import { isGuestUrlPermissionLevel } from '../isGuestUrlPermissionLevel';

export function isUnshareable(sharingData: SharingData): boolean {
    return (
        sharingData.sharingInfo &&
        sharingData.sharingInfo.getSharingInfoSucceeded &&
        !sharingData.sharingInfo.canShareInternally &&
        !isGuestUrlPermissionLevel(sharingData.currentPermissionLevel) // Guest urls can be shared even if the user doesn't have permission to give access
    );
}
